import React from "react";

export const AppContext = React.createContext({});
export const MapContext = React.createContext({});
